import { withInstall } from '@ll-plus/utils'

import Dropdown from './src/dropdown.vue'
import DropdownButton from './src/dropdown-button.vue'

export const LlDropdown = withInstall(Dropdown)
export const LlDropdownButton = withInstall(DropdownButton)
// export default LlDropdown
export * from './src/dropdown'

declare module 'vue' {
  export interface GlobalComponents {
    LlDropdown: typeof Dropdown
    LlDropdownButton: typeof DropdownButton
  }
}
